import { RouteComponentProps } from '@reach/router';
import React from "react";
import { useTranslation } from 'react-i18next';
import Footer from '../../basics/Footer';
import NoFolder from "../../../assets/img/undraw-not-found.png";
import StructuresHeader from '../dossiers/StructuresHeader';

interface StructureDisabledProps extends RouteComponentProps {
}

const StructureDisabled: React.FC<StructureDisabledProps> = ({ }) => {
	const { t } = useTranslation();

	return (
		<div id="structure" className="structure__unauthorized">
			<div className="modal">
				<StructuresHeader isStructurePendingOrDisabled />
				<div className="structure__unauthorizedContent">
					<img src={NoFolder} className="unauthorizedImg" />
					<p>{t("unauthorized-page.disabled.part1")}</p>
					<p>{t("unauthorized-page.disabled.part2")}</p>
					<p><b>{t("unauthorized-page.disabled.part3")}</b></p>
				</div>
				<div className="structure__footer">
					<Footer />
				</div>
			</div>
		</div>
	);
};

export default StructureDisabled;